import paragraph_icon from '../assets/paragraph_icon.png';
import gift_icon from '../assets/gift_icon.png';
import not_sure_icon from '../assets/not_sure_icon.png';
import next_caret_dark from '../assets/caret_dark_icon.png';
import { useState, useEffect, useCallback } from 'react';

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Cookie like "csrftoken=<value>"
        if (cookie.substring(0, name.length + 1) === (name + "=")) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
        }
        }
    }
    return cookieValue;
}


export default function GetStarted(props) {
    const [isFocused, setIsFocused] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [placeholderText, setPlaceholderText] = useState('What will your chapter be about?');
    const placeholderOptions = [
        "My college years",
        "Leaving home",
        "My first job",
        "Getting married",
        "Becoming a parent",
        "Losing a loved one",
        "Dealing with an addiction",
        "My divorce",
        "Starting my own business",
        "How I met my spouse",
        "My career",
        "How I got my big break",
        "Adventures abroad",
        "Retirement",
        "Life Lessons",
        "Childhood friends",
        "Why I left my hometown",
    ];
    useEffect(() => {
        if (isFocused) return;

        let currentOptionIndex = 0;
        let isTyping = true;
        let currentText = '';
        let charIndex = 0;
        let timeoutId;

        const animatePlaceholder = () => {
            if (isFocused) return;
            if (isTyping) {
                // Typing animation
                if (charIndex < placeholderOptions[currentOptionIndex].length) {
                    currentText = placeholderOptions[currentOptionIndex].slice(0, charIndex + 1);
                    charIndex++;
                    timeoutId = setTimeout(animatePlaceholder, 100); // Typing speed
                } else {
                    // Pause before starting delete
                    isTyping = false;
                    timeoutId = setTimeout(animatePlaceholder, 1000); // Wait 1 second
                }
            } else {
                // Deleting animation
                if (charIndex > 0) {
                    currentText = placeholderOptions[currentOptionIndex].slice(0, charIndex - 1);
                    charIndex--;
                    timeoutId = setTimeout(animatePlaceholder, 50); // Deletion speed (faster than typing)
                } else {
                    // Move to next option
                    isTyping = true;
                    currentOptionIndex = (currentOptionIndex + 1) % placeholderOptions.length;
                    timeoutId = setTimeout(animatePlaceholder, 500); // Pause before next word
                }
            }
            setPlaceholderText(currentText);
        };

        timeoutId = setTimeout(animatePlaceholder, 500);
        return () => {clearTimeout(timeoutId);}

    }, [isFocused]);

    async function handleSubmitChapterTopic(e) {
        e.preventDefault();
        
        const formValues = Object.fromEntries(new FormData(e.target));
        const message = formValues.chapter_topic;

        setIsLoading(true);
        
        try {
            // First, ensure we have a CSRF token and session
            await fetch('/api/get_csrf/', {
                credentials: 'include'
            });
            
            // Get CSRF token
            const csrfToken = getCookie('csrftoken');
            
            // Now make the actual API call
            const response = await fetch('/api/log_first_message', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({ 
                    chapter_topic: message
                }),
            });
            console.log(response);
            if (response.ok) {
                console.log("success!")
                props.navigateToSignup();
            } else {
                console.log("error!")
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            // Hide loading overlay regardless of success or failure
            setIsLoading(false);
        }
    }
    return (
        <div id={props.id}>
            {/* Loading overlay */}
            {isLoading && (
                <div className="opaque-overlay">
                    <div className="loading-spinner"></div>
                </div>
            )}
            <div className="line-container">
                <span className="horizontal-line line-left"></span>
                <div className="pill-box">
                    How do I get started?
                </div>
                <span className="horizontal-line line-right"></span>
            </div>
            <h1 className="samples-title">Let's figure out what your chapter will be about</h1>
            <h2 className="samples-subtitle">Even if you don't know exactly what you want to cover, just give us a general idea and we'll figure it out together.</h2>
            <div className="users-story-container">      
                <div className="users-story expanded">
                    <div className="users-story-title-container">
                        <img src={paragraph_icon} className="chapter-sample-paragraph-icon"/>
                        <div className="chapter-sample-title-container">
                            <h3 className='chapter-expanded-sample-title'>Your First Chapter</h3>
                            <p className='chapter-expanded-sample-subtitle'>What will your chapter be about?</p>
                        </div>
                    </div>
                    <div className="users-story-input-container">
                        <form 
                            className="form-users-story-input" 
                            onSubmit={handleSubmitChapterTopic}
                        >
                            <div className="users-story-input-label-container">
                                <input 
                                    type="text" 
                                    className="users-story-input-field" 
                                    name="chapter_topic"
                                    placeholder={isFocused ? "" : placeholderText}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => setIsFocused(false)}
                                />
                            </div>
                            <button className="users-story-button-desktop"></button>
                            <button className="users-story-button-mobile">Get Started <img src={next_caret_dark} className="gray-pill-box-next-icon"/></button>
                        </form>
                        <div className="gray-pill-box-container">
                            <div className="gray-pill-box clickable-pill-box"> 
                                <img src={not_sure_icon} className="gray-pill-box-icon"/>
                                Not sure
                                <img src={next_caret_dark} className="gray-pill-box-next-icon"/>
                            </div>
                            <div className="gray-pill-box clickable-pill-box" onClick={props.navigateToGiveGift}> 
                                <img src={gift_icon} className="gray-pill-box-icon"/> 
                                Give as gift 
                                <img src={next_caret_dark} className="gray-pill-box-next-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}